/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import styled from "styled-components";
import Card from "../Cards/Card";
import socialIllustration from "../../assets/illustrations/social.svg";
import { TextSubtitle, TextTitle } from "../../styles";
import InlineLink from "../InlineLink";
import GoogleButton from "../Buttons/GoogleButton";
import GithubButton from "../Buttons/GithubButton";
import FacebookButton from "../Buttons/FacebookButton";

interface SocialPageProps {
    handleView: React.Dispatch<React.SetStateAction<string>>;
    socialSignin: (provider: any) => Promise<void>;
}

const SocialPage: React.FC<SocialPageProps> = ({
    handleView,
    socialSignin,
}) => {
    const _handleGoogleClick = () => {
        socialSignin && socialSignin("google");
    };
    const _handleFacebookClick = () => {
        socialSignin && socialSignin("facebook");
    };
    return (
        <Card alt="social login" imageSrc={socialIllustration}>
            <LeftContainer>
                <TextContainer>
                    <Title>Social Log in</Title>
                    <Subtitle>Use your social accounts to log in.</Subtitle>
                </TextContainer>
                <ButtonContainer>
                    <GoogleButton onClick={_handleGoogleClick} />
                    <FacebookButton onClick={_handleFacebookClick} />
                </ButtonContainer>
                <ExtraContainer>
                    <InlineLink
                        text="Log in with email?"
                        textLink="Email log in"
                        handleView={() => handleView("login")}
                    />
                    <InlineLink
                        text="Don't have an account?"
                        textLink="Sign up!"
                        handleView={() => handleView("signup")}
                    />
                    <InlineLink
                        text="Forgot your password?"
                        textLink="Reset password"
                        handleView={() => handleView("reset")}
                    />
                </ExtraContainer>
            </LeftContainer>
        </Card>
    );
};

const LeftContainer = styled.div`
    align-content: center;
    display: grid;
    gap: 1.5em;
    grid-template-rows: repeat(3, min-content);
    height: 100%;
    width: 500px;
    @media (max-width: 1000px) {
        width: 450px;
    }

    @media (max-width: 768px) {
        width: 400px;
    }

    @media (max-width: 650px) {
        width: 300px;
    }

    @media (max-width: 450px) {
        width: 98%;
    }
`;

const TextContainer = styled.div`
    display: grid;
    gap: 0.2em;
`;

const Title = styled(TextTitle)``;

const Subtitle = styled(TextSubtitle)``;

const ButtonContainer = styled.div`
    display: grid;
    gap: 1em;
    grid-template-columns: 210px;
`;

const ExtraContainer = styled.div`
    display: grid;
    gap: 0.5em;
    grid-template-rows: repeat(2, min-content);
`;

export default SocialPage;
